import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PriceService } from '../../services/price.service';
import { CmsService } from '../../services/cms.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Networks } from '../../../shared/models/networks.enum';
import { ActivatedRoute } from '@angular/router';
import { ComponentCtaLinkPipe } from '../../pipes/component-cta-link.pipe';
import { ProjectService } from "../../../shared/services/project.service";
import { environment } from 'src/environments/environment';
import { BrandCardParentIds } from '../../config/feature.config';

@Component({
  selector: 'ui-card',
  templateUrl: './ui-card.component.html',
  styleUrls: ['./ui-card.component.scss']
})
export class UiCardComponent implements OnInit, OnDestroy {
  @Input() component: any;
  @Input() parent: any;

  private unsubscribe$ = new Subject<any>();

  public livePrice = null;
  public isPriceLoading = false;
  public networks = Networks;
  public isCndAttributeVisible: boolean;

  public imageToUse;
  public brand;

  public isLanding: boolean;



  public isLinkInitialized: boolean = false;
  public link: string;

  public brandContainerIds = environment.production ? BrandCardParentIds.prod : BrandCardParentIds.pre;
  public isParentBrandContainer = false;

  private _timeoutIDs: ReturnType<typeof setTimeout>[] = [];
  private readonly GetPagesTimeout: number = 450;
  private readonly GetPagesTryAmount: number = 3;

  // componentCtaLink:component?.content?.ctaType?.id

  constructor(
    private _priceService: PriceService,
    private _cmsService: CmsService,
    private _route: ActivatedRoute,
    private _projectService: ProjectService
  ) { }

  ngOnInit(): void {
    const segments = this._route.snapshot['_urlSegment'].segments.map(x => x.path);
    this.isLanding = segments[0] == 'landing';

    this._cmsService.allNews$.pipe(takeUntil(this.unsubscribe$)).subscribe(news => {
        if (news) {
          if (this.component.content.ctaTarget === 'conad-news') {
            this.isCndAttributeVisible = news.filter(x => x.attributes.some(x => x.includes('heyconad'))).length > 0;
          }
        }
    });

    this._cmsService.brandConfig$.pipe(takeUntil(this.unsubscribe$)).subscribe(brand => {
      if (brand) this.brand = brand;
    });
    if (this.component.content.livePrice) {
      this.isPriceLoading = true;
      this._priceService.getLivePrice(this.component.content.products[0]).then(
        (price) => {
          this.livePrice = price;
          if (this.livePrice == null) this.component.content.livePrice = false;
          this.isPriceLoading = false;
        },
        (error) => {
          if (this.component.content.livePrice){
            if (this.component?.content?.products?.length > 0 && this.component?.content?.products[0]?.tourOperator?.id !== 1101) {
              const halfPrice = (Math.round(Number(this.component.content.price.split(" ")[0]) / 2)).toString() + ' €';
              this.component.content.price = halfPrice;
            }
          }
          this.component.content.livePrice = false;
          this.livePrice = null;
          this.isPriceLoading = false;
        }
      );
    }

    this._cmsService.mobileView$.pipe(takeUntil(this.unsubscribe$)).subscribe(isMobile => {
      if (isMobile && this.component.componentConfig.subType == 'banner-network' && this.parent.componentConfig.subType == 'RESERVED') {
        this.imageToUse = this.component.content.images[0] ? this.component.content.images[0].path : this.component.content.image;
      } else {
        this.imageToUse = this.component.content.image;
      }
    });

    if (this.component.content.ctaType) {
      this._timeoutIDs.push(setTimeout(() => {
        this.getPages().then(
          (pages) => {
            // FIXME hardcoded logic 08/05/2024 Conad release
            if (this.parent.attributes.some(x => x.includes('heyconad'))) {
              this.link = "/conad";
            } else {
              this.link = new ComponentCtaLinkPipe().transform(this.component.content, this.component.content.ctaType.id, pages);
              if(this.link?.toLowerCase().includes('viaggi.conad.it')){
                this._projectService.getProfile().pipe(takeUntil(this.unsubscribe$)).subscribe(e => {
                  this.link +=  `?agReferral=${e.id}`;
                })
              }
            }
            this.isLinkInitialized = true;
          },
          (error) => {
            // TODO manage error, check with UI/UX specialists the best approach
          }
        );
      }, this.GetPagesTimeout));



    } else {
      this.isLinkInitialized = true;

    };

    this.isParentBrandContainer = this.brandContainerIds.includes(this.parent?.componentConfig?.id);
  }

  ngOnDestroy(): void {
    this._timeoutIDs.forEach(id => clearTimeout(id));
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  private getPages(retry: number = 1): Promise<any> {
    return new Promise((resolve, reject) => {
      const pages = this._cmsService.getPages();

      if (pages !== undefined) {
        resolve(pages);
      } else {
        if (retry < this.GetPagesTryAmount) {
          this._timeoutIDs.push(
            setTimeout(() => {
              resolve(this.getPages(retry + 1));
            }, this.GetPagesTimeout)
          );
        } else {
          console.error("CANNOT GET PAGES, TRY NUMBER  " + retry);
          reject("Max retry attempts reached");
        }
      }
    });
  }

}
